import React, { useState, useEffect } from "react";
import {
  View,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
  Linking,
} from "react-native";
import Text from "@components/AppText";
import colors from "@constants/color";
import CloseIcon from "@assets/svg/CloseIcon";
import WhatsApp from "@assets/svg/WhatsApp";
import Caret from "@assets/svg/Caret";
import metrics from "@constants/metrics";
import { getReferedCustomers } from "@services/api";
import CustomText from "@components/CustomText";

import t from "@constants/localization";

const PATH = "screens/ReferralList";

const ReferralList = (props) => {
  const [customers, setCustomers] = useState([]);
  useEffect(() => {
    fetchReferedCustomers();
  }, []);

  const fetchReferedCustomers = async () => {
    try {
      const { data: customers } = await getReferedCustomers();

      setCustomers({ customers });
    } catch (e) {
      console.log(e);
    }
  };

  const openWhatsApp = (number) => {
    Linking.openURL(`whatsapp://send?phone=91${number}`);
  };

  return (
    <ScrollView>
      <View style={styles.topHeader}>
        <TouchableOpacity
          style={styles.iconCont}
          onPress={() => {
            props.navigation.goBack();
          }}
        >
          <CloseIcon fill={colors.black} />
        </TouchableOpacity>

        <View style={styles.mainHeader}>
          <CustomText
            variant="subtitle_16"
            style={{
              textAlign: "center",
            }}
          >
            {t(`${PATH}/yourReferral`)}
          </CustomText>
        </View>
      </View>

      {Array.isArray(customers.customers) &&
        customers.customers.length > 0 &&
        customers.customers.map((referal, i) => {
          return (
            <View key={i} style={{}}>
              <View style={styles.userOuterCont}>
                <View style={styles.userInnerCont}>
                  <Text fontType="head1" style={styles.name}>
                    {referal.user_name}
                  </Text>
                  <View style={styles.numberCont}>
                    <WhatsApp />
                    <Text style={styles.number}>{referal.user_phone}</Text>
                    <TouchableOpacity
                      style={styles.arrow}
                      onPress={() => {
                        openWhatsApp(referal?.user_phone);
                      }}
                    >
                      <Caret height={16} width={16} />
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
            </View>
          );
        })}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  topHeader: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: colors.darkBackground,
    padding: 14,
  },
  iconCont: {},
  mainHeader: {
    flex: 1,
  },
  userOuterCont: {
    flexDirection: "column",
    width: "100%",
    borderBottomWidth: 1,
    borderBottomColor: colors.silver,
  },
  userInnerCont: {
    marginHorizontal: metrics.mainContainerPadding,
    marginVertical: metrics.cardPadding,
  },
  name: { marginBottom: 16, marginHorizontal: 4 },
  numberCont: {
    flexDirection: "row",
    width: "100%",
    paddingRight: 16,
    paddingLeft: 8,
    alignItems: "center",
  },
  number: { marginHorizontal: 16 },
  arrow: {
    padding: 4,
  },
});

export default ReferralList;
